import type { BlockInterface, Fields } from 'types/builder/interface';

import { createEvent } from 'effector';

// * events
export const addSigningBlockEvent = createEvent<{
    block: BlockInterface;
}>();
export const addSigningBlockRowEvent = createEvent<{
    component: string;
    blockId: string;
    clause: Fields;
}>();
export const addSigningBlockSectionToRowEvent = createEvent<{
    blockId: string;
    clause: Fields;
}>();
export const reorderSigningBlockFieldsInGroup = createEvent<{
    groupId: string;
    items: Fields[];
}>();
export const deleteSigningBlockSectionEvent = createEvent<{
    blockId: string;
    fieldId: string;
}>();
